import { useLocation } from 'react-router'

import { ScratchpadScene } from './ScratchpadScene'

export const ScratchpadRoute = () => {
  const location = useLocation()

  // Scratchpads need to be reinitialised across layers and local state needs to be discarded, so we use the location as a key to force a remount of the component when the path changes
  return <ScratchpadScene key={location.pathname} />
}
